import axios from "axios";
import App from "../main";
import AppService from "./appService";

var instance = axios.create({
	baseURL: "https://api.appmastery.co/api/v1/apps",
});
instance.interceptors.request.use(
	function(config) {
		// Do something before request is sent
		var token = AppService.getAuthToken();
		if (token) {
			//    config.headers['Authorization'] = token;
		}
		return config;
	},
	function(error) {
		// Do something with request error
		return Promise.reject(error);
	}
);

instance.interceptors.response.use(
	function(response) {
		// Do something with response data

		return response;
	},
	function(error) {
		var status = error.response.status;
		if (status == 401) {
			App.$router.push({ name: "login" });
		}
		// Do something with response error
		return Promise.reject(error);
	}
);

export default instance;
